
import { mapMutations } from 'vuex'

export default {
  name: 'NoCategoryResults',
  methods: {
    ...mapMutations([ 'setSearchedMenu' ]),
  }
}
